var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2546_64835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 0.833252C8.18766 0.833252 6.41538 1.37087 4.90793 2.37811C3.40048 3.38536 2.22556 4.817 1.53176 6.49198C0.837956 8.16697 0.656426 10.0101 1.01012 11.7882C1.36382 13.5664 2.23686 15.1997 3.51884 16.4817C4.80082 17.7637 6.43417 18.6367 8.21233 18.9904C9.99048 19.3441 11.8336 19.1626 13.5086 18.4688C15.1836 17.775 16.6152 16.6001 17.6225 15.0926C18.6297 13.5852 19.1673 11.8129 19.1673 9.99992C19.1673 8.79613 18.9302 7.60414 18.4695 6.49198C18.0089 5.37983 17.3337 4.36931 16.4825 3.51811C15.6313 2.6669 14.6207 1.99169 13.5086 1.53102C12.3964 1.07035 11.2044 0.833252 10.0007 0.833252ZM13.9607 9.08325L9.68898 13.3641C9.5892 13.4639 9.47054 13.5429 9.33991 13.5964C9.20928 13.6499 9.06931 13.6769 8.92815 13.6757C8.78839 13.6767 8.64985 13.6496 8.52074 13.5961C8.39163 13.5425 8.27457 13.4637 8.17649 13.3641L6.04065 11.2099C5.84926 11.0089 5.74402 10.7411 5.7474 10.4636C5.75078 10.1861 5.86252 9.92093 6.05876 9.72469C6.255 9.52845 6.52018 9.41671 6.79769 9.41333C7.07519 9.40994 7.34302 9.51519 7.54399 9.70658L8.92815 11.0816L12.4573 7.56158C12.5572 7.46287 12.6756 7.38481 12.8057 7.33185C12.9358 7.27889 13.075 7.25207 13.2155 7.25292C13.3559 7.25377 13.4948 7.28227 13.6243 7.33681C13.7537 7.39134 13.8711 7.47084 13.9698 7.57075C14.0685 7.67066 14.1466 7.78904 14.1996 7.91913C14.2525 8.04921 14.2793 8.18845 14.2785 8.3289C14.2776 8.46935 14.2491 8.60825 14.1946 8.73768C14.1401 8.86712 14.0606 8.98454 13.9607 9.08325Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2546_64835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteChat);
export default __webpack_public_path__ + "static/media/CompleteChat.a50d84c8ab1dd0f08da8af47ee6b954b.svg";
export { ForwardRef as ReactComponent };